"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseLayerFactory_27700 = void 0;
var BaseLayerType_1 = require("../baselayers/BaseLayerType");
var BaseLayer_1 = require("./BaseLayer");
var XYZ_1 = require("ol/source/XYZ");
var Tile_1 = require("ol/layer/Tile");
var Projection_1 = require("ol/proj/Projection");
var BaseLayerFactory_27700 = /** @class */ (function () {
    function BaseLayerFactory_27700() {
    }
    BaseLayerFactory_27700.prototype.GetBaseLayerByType = function (baseLayerType, bingApiKey, esdmApiKey) {
        if (bingApiKey === void 0) { bingApiKey = ""; }
        if (esdmApiKey === void 0) { esdmApiKey = ""; }
        var lyr = null;
        switch (baseLayerType) {
            case (BaseLayerType_1.BaseLayerType.OSM, BaseLayerType_1.BaseLayerType.BingAerial, BaseLayerType_1.BaseLayerType.BingOS):
                //not supported
                console.warn("".concat(baseLayerType, " layer not configured for 27700, layer is only available in 3857"));
                break;
            case BaseLayerType_1.BaseLayerType.OSM_ESDM_contours:
                lyr = this.OSM_ESDM_contours(esdmApiKey, "OSM_ESDM_contours", "OpenStreetMap");
                break;
            case BaseLayerType_1.BaseLayerType.OSM_ESDM_nocontours:
                lyr = this.OSM_ESDM_nocontours(esdmApiKey, "OSM_ESDM_nocontours", "OpenStreetMap");
                break;
            case BaseLayerType_1.BaseLayerType.OS_Open_Data:
                console.warn("".concat(baseLayerType, " layer not configured"));
                break;
            default:
                console.warn("".concat(baseLayerType, " layer not configured for 27700"));
                break;
        }
        return lyr;
    };
    BaseLayerFactory_27700.prototype.OSM_ESDM_contours = function (esdmApiKey, ref, displayName) {
        var lyr = new Tile_1.default({
            source: new XYZ_1.default({
                projection: new Projection_1.default({
                    code: 'EPSG:27700',
                    extent: [-350000, -100000, 1050000, 1300000]
                }),
                url: "//{a-f}.osm.esdm.co.uk/27700/c/{z}/{x}/{y}.png?APIKEY=".concat(esdmApiKey),
            })
        });
        return new BaseLayer_1.BaseLayer(ref, displayName, lyr);
    };
    BaseLayerFactory_27700.prototype.OSM_ESDM_nocontours = function (esdmApiKey, ref, displayName) {
        var lyr = new Tile_1.default({
            source: new XYZ_1.default({
                projection: new Projection_1.default({
                    code: 'EPSG:27700',
                    extent: [-350000, -100000, 1050000, 1300000]
                }),
                url: "//{a-f}.osm.esdm.co.uk/27700/u/{z}/{x}/{y}.png?APIKEY=".concat(esdmApiKey),
            })
        });
        return new BaseLayer_1.BaseLayer(ref, displayName, lyr);
    };
    return BaseLayerFactory_27700;
}());
exports.BaseLayerFactory_27700 = BaseLayerFactory_27700;
//# sourceMappingURL=BaseLayerFactory_27700.js.map